import Axios from "axios";

// Create a public axios instance without authentication
const BASE_API_URL = process.env.REACT_APP_BASE_API_URL || "/api";
const publicAxios = Axios.create({ baseURL: BASE_API_URL });

export interface Document {
  id: string;
  title: string;
  type: string;
  description?: string;
  url: string;
  isActive: boolean;
  sortOrder: number;
  createdAt: string;
  updatedAt: string;
}

export interface ApiResponse<T> {
  code: number;
  message: string;
  data: T;
}

export const documentApi = {
  getAllDocuments: async (): Promise<ApiResponse<Document[]>> => {
    const response = await publicAxios.get("/documents");
    return response.data;
  },
};
